// data/languages/copte/categories/objets.ts

import { CategoryData } from '../../../../types/types';

export const objets: CategoryData = {
    // Objets du quotidien - dialecte bohaïrique. Sources : Wiktionary (Coptic entries) et
    // Coptic Dictionary Online / TLA. ⲏⲓ et ⲙⲱⲓⲧ sont aussi confirmés par du contenu déjà
    // présent ailleurs dans l'app (grammaire.ts, sentencesgap.ts). Liste volontairement
    // courte : seuls les mots vérifiables via une source ont été retenus.
    'ⲏⲓ (êi)': {
        translation: 'La maison',
        translationEn: 'The house',
        illustration: '🏠',
        audio: 'Co-Ei'
    },
    'ϫⲱⲙ (jôm)': {
        translation: 'Le livre',
        translationEn: 'The book',
        illustration: '📖'
    },
    'ⲣⲟ (ro)': {
        translation: 'La porte',
        translationEn: 'The door',
        illustration: '🚪',
        audio: 'Co-Ro'
    },
    'ϩⲁⲧ (hat)': {
        translation: "L'argent",
        translationEn: 'The money',
        illustration: '💰'
    },
    'ⲙⲱⲓⲧ (môit)': {
        translation: 'La route, le chemin',
        translationEn: 'The road, the path',
        illustration: '🛣️'
    },
    'ⲥⲏϥⲓ (sêfi)': {
        translation: 'Le couteau',
        translationEn: 'The knife',
        illustration: '🔪'
    },
    'ϩⲃⲱⲥ (hbôs)': {
        translation: 'Le vêtement',
        translationEn: 'The clothing',
        illustration: '👕'
    },
};

export default objets;
